import { applyMiddleware, createStore, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from './root.epic';
import { rootReducer } from './root.reducer';
import { createWrapper } from 'next-redux-wrapper';

const epicMiddleware = createEpicMiddleware();
const composeEnhancers = compose;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(epicMiddleware)));

export const configureStore = () => {
  epicMiddleware.run(rootEpic);
  return store;
};

export const makeStore = () => configureStore();

export const wrapper = createWrapper(makeStore, { debug: true });
